import { createUrl } from "@touchtech/web-api-client";

import { getEnvValue } from "@is/utils/env";

const baseUrl = getEnvValue("VITE_TENANTS_SERVICE_URL");

export const createTenantUrl = (id: string) =>
  createUrl(baseUrl, `api/tenants/incog/${id}`);

export const createConfigurationUrl = () =>
  createUrl(baseUrl, "api/View/incog/configuration");
